import React, { Component } from 'react';
import { Table, Row, Col, Modal, Button, Image, FormGroup, ControlLabel } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import { DropdownList } from 'react-widgets';
import IconButton from '../FormComponents/IconButton';

class Users extends Component{
  constructor(props){
    super(props);
    this.props.loadUsers();
    let { blocked, expired } = this.props.location.query;
    this.state = {
      deleteModal: false,
      modalMessage: "",
      modalCallback: () => false,
      filter: [],
      blocked: !blocked ? false : blocked === 'true',
      expired: !expired ? false : expired === 'true',
      department: null,
      group: null,
      bonus_group: null,
      type: null
    }
  }

  handleDepartmentChange(value){
    this.setState({department:value==='All'?null:value});
  }

  handleGroupChange(value){
    this.setState({group:value==='All'?null:value});
  }

  handleBonusGroupChange(value){
    this.setState({bonus_group:value==='All'?null:value});
  }

  handleTypeChange(value){
    this.setState({type:value==='All'?null:value});
  }

  handleBlockedChange(opt){
    let blocked=opt.v;
    this.setState({page:1,blocked});
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        blocked
      }
    })
  }

  handleExpiredChange(opt){
    let expired = opt.v;
    this.setState({ page: 1, expired });
    browserHistory.push({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        page:1,
        expired
      }
    })
  }

  render(){
    const closeModal=()=>{this.setState({deleteModal:false})}
    if (this.props.users_loaded){
      const departments = ['All',...new Set(this.props.users.map(u=>u.department).filter(Boolean))];
      const groups = ['All',...new Set(this.props.users.map(u=>u.group).filter(Boolean))];
      const bonus_groups = ['All',...new Set(this.props.users.map(u=>u.bonus_group).filter(Boolean))];
      const types = ['All','admin','supervisor','user'];
      const filteredUsers = this.props.users.filter(user => {
        let { userid, name, department, type, group, bonus_group, locked, password_expired } = user;
        const search_string = `${userid} ${name} ${department} ${type} ${group} ${bonus_group}
          ${locked?'blocked':'enabled'} ${password_expired?'expired':'active'}`.toLowerCase();
        let match = ((this.state.blocked == null) || (this.state.blocked === locked)) &&
                    ((this.state.expired == null) || (this.state.expired === password_expired)) &&
                    ((this.state.department == null) || (this.state.department === department)) &&
                    ((this.state.group == null) || (this.state.group === group)) &&
                    ((this.state.bonus_group == null) || (this.state.bonus_group === bonus_group)) &&
                    ((this.state.type == null) || (this.state.type === type));

        this.state.filter.forEach(fi=>{
          match = match && (search_string.indexOf(fi) > -1);
        });
        return match;
      });
      return (
        <div id="users">
            <Row>
              <Col xs={6}>
                <h1>Users</h1>
              </Col>
              <Col xs={6}>
                <IconButton type="create" redirect="/users/new" right>Create</IconButton>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <label htmlFor="filter">Search</label><br />
                <input name="filter" 
                  className="form-control" 
                  type="text" 
                  placeholder="Filter" 
                  onChange={v=>{this.setState({filter:v.target.value.toLowerCase().split(" ")})}}/>
              </Col>
              <Col xs={12} sm={3}>
                <label htmlFor="blocked">Blocked</label><br />
                <DropdownList name="blocked"
                  data={[{l:'all',v:null},{l:'blocked',v:true},{l:'enabled',v:false}]}
                  value={this.state.blocked}
                  textField="l"
                  valueField="v"
                  onChange={this.handleBlockedChange.bind(this)} />
              </Col>  
              <Col xs={12} sm={3}>
                <label htmlFor="expired">PW Expired</label><br />
                <DropdownList name="expired"
                  data={[{l:'all',v:null},{l:'expired',v:true},{l:'active',v:false}]}
                  value={this.state.expired}
                  textField="l"
                  valueField="v"
                  onChange={this.handleExpiredChange.bind(this)} />
              </Col>  
              <Col xs={12} sm={3} >
                <FormGroup>
                  <ControlLabel>Records</ControlLabel>
                  <p className="form-control-static records-count">
                    {this.props.users_loading ? 'Loading...' : `${filteredUsers.length} ( ${this.props.users.length} )`}
                  </p>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <label htmlFor="department">Position</label><br />
                <DropdownList name="department"
                  data={departments}
                  value={this.state.department||'All'}
                  filter="contains"
                  onChange={this.handleDepartmentChange.bind(this)} />
              </Col>
              <Col xs={12} sm={3}>
                <label htmlFor="group">Group</label><br />
                <DropdownList name="group"
                  data={groups}
                  value={this.state.group||'All'}
                  filter="contains"
                  onChange={this.handleGroupChange.bind(this)} />
              </Col>
              <Col xs={12} sm={3}>
                <label htmlFor="bonus_group">Bonus group</label><br />
                <DropdownList name="bonus_group"
                  data={bonus_groups}
                  value={this.state.bonus_group||'All'}
                  filter="contains"
                  onChange={this.handleBonusGroupChange.bind(this)} />
              </Col>
              <Col xs={12} sm={3}>
                <label htmlFor="type">Type</label><br />
                <DropdownList name="type"
                  data={types}
                  value={this.state.type||'All'}
                  onChange={this.handleTypeChange.bind(this)} />
              </Col>
            </Row>
            <Table className="crud-table" >
              <thead>
                <tr>
                  <th></th>
                  <th>User ID</th>
                  <th>Name</th>
                  <th className="hidden-xs">Position</th>
                  <th className="hidden-xs">Group</th>
                  <th className="hidden-xs">Bonus group</th>
                  <th>Type</th>
                  <th className="hidden-xs">Blocked</th>
                  <th className="hidden-xs">PW Expired</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user=>{
                  return (
                    <tr key={user._id}>
                      <td><Image width={50} height={50} src={user.avatar||"/img/profile.jpg"} rounded/></td>
                      <td>{user.userid}</td>
                      <td>{user.name}</td>
                      <td className="hidden-xs">{user.department}</td>
                      <td className="hidden-xs">{user.group}</td>
                      <td className="hidden-xs">{user.bonus_group}</td>
                      <td>{user.type}</td>
                      <td className="hidden-xs">{user.locked?'blocked':'enabled'}</td>
                      <td className="hidden-xs">{user.password_expired?'expired':'active'}</td>
                      <td>
                        {this.props.auth.type==='admin'&&(
                        <IconButton type="delete" onClick={()=>{
                          this.setState({
                            deleteModal:true,
                            modalMessage:`Are you sure you want to delete ${user.name}? This action is permanent.`,
                            modalCallback:()=>{this.props.deleteUser(user._id);closeModal();}
                          });
                        }}>Delete</IconButton>
                        )}
                        <IconButton type="edit" redirect={"/users/"+user._id}>Edit</IconButton>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
            <Modal show={this.state.deleteModal} onHide={closeModal}>
              <Modal.Header>Confirm delete...</Modal.Header>
              <Modal.Body>{this.state.modalMessage}</Modal.Body>
              <Modal.Footer>
                <Button onClick={closeModal}>Cancel</Button>
                <Button onClick={this.state.modalCallback}>Confirm</Button>
              </Modal.Footer>
            </Modal>
        </div>
      )
    }
    else {
      return (
        <div className="loading">

        </div>
      );
    }
  }
}

export default Users;
